<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Course Update Notification
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark color="white">fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container class="mb-5">
      <v-row>
        <v-col md="12">
          <v-form>
            <v-radio-group v-model="notification.type" row>
              <label class="font-weight-medium mb-2 d-block">Course Update Notification:</label>
              <!-- <v-radio label="None" value="None" class="pl-4"></v-radio> -->
              <div class="d-flex flex-row">
                 <v-radio label="New" value="New" class=""></v-radio>
                 <v-radio label="Updated" value="Update" class=""></v-radio>
              </div>
            </v-radio-group>
            <v-layout class="mb-5 d-block">
              <ckeditor :editor="editor" class="ckeditor" v-model="notification.description" tag-name="textarea"
                :config="editorConfig"></ckeditor>
                <div class="v-text-field__details" v-if="messages.description">
                  <span class="v-messages theme--light error--text" > {{ messages.description[0] }} </span>
                </div>
            </v-layout>
            <v-layout class="mb-5">
              <v-text-field :error-messages="messages.notification_display_days"
                v-model="notification.notification_display_days" label="Show notification for [X] days:" type="number"
                class="duration" filled :min="1" :max="100" @keypress="NumbersOnly"
                @blur="handleDisplayNotificationBlur()">
                <template slot="append-outer">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">fa fa-question</v-icon>
                    </template>
                    <span>Enter the number of days this notification should be visible.</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-layout>
            <span v-if="notification.notification_visible_until">Notification Visible Until : {{ notification.notification_visible_until  }}</span>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-footer height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!loading" color="grey300" class="cancel-button" @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="dark-blue" class="ml-4 add-course-button" @click="saveNotification"
          :disabled="!notification.hasOwnProperty('type')">Save</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import courseAPI from "@/api/course.js";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EventBus } from '@/event-bus.js';
export default {
  name: "UpdateNotification",
  components: {},
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      editorConfig: {
        toolbar: {
          items: [
            'undo', 'redo',
            '|', 'heading',
            '|', 'bold', 'italic',
            '|', 'bulletedList', 'numberedList',
            '|', 'link'
          ]
        },
      },
      editor: ClassicEditor,
      notification: {
      },
      messages: {},
      loading: false,
      successMessage: "Notification Successfully Saved.",
      errorMessage: "Oops, something went wrong! Please check information is correct.",
    };
  },
  mounted() {
    this.setEventBus();
    this.getCourseUpdateNotification();
  },
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode == 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleDisplayNotificationBlur() {
      const value = parseInt(this.notification.notification_display_days, 10);
      if (value == 0) {
        this.notification.notification_display_days = 1;
      }
      if (value > 100) {
        this.notification.notification_display_days = 100;
      }
    },
    setEventBus() {

    },
    getCourseUpdateNotification() {
      this.loading = true;
      courseAPI.getCourseUpdateNotification(this.id).then((resp) => {
        this.notification = resp.data.data;
        this.notification.course_id = this.id;
        this.notification.course_name = this.name;
        this.loading = false;
      }).catch(() => {
        this.$snotify.error(this.errorMessage);
        this.loading = false;
      });
    },
    saveNotification() {
      this.loading = true;
      courseAPI.saveCourseUpdateNotification(this.notification).then((resp) => {
         this.closePanel();
         this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
              EventBus.$emit('COURSES_UPDATED', '');
      }).catch((err) => {
        this.messages = this.$gf.errorResponse(err);
        this.$snotify.error(this.errorMessage);
        this.loading = false;
        setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      });
    }
  }
};
</script>